import { render } from "./CheckBoxField.vue?vue&type=template&id=1cb86225"
import script from "./CheckBoxField.vue?vue&type=script&lang=js"
export * from "./CheckBoxField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__